export default __webpack_public_path__ + "static/media/img-02.b9e68b2b.jpg";